import { TypeOfSubjectAction  } from '../types/TypeOfSubjectAction';
import { TypeOfSubjectBody } from '../types/TypeOfSubjectBody';


interface subjectState {
    list: TypeOfSubjectBody[],
    error: boolean | false,
  };
  
  const initialState: subjectState = {
    list: [],
    error: false,
  };


const goalReducer = (state = initialState, action: TypeOfSubjectAction) => {
    switch (action.type) {
      case 'TypeOfSubject_SUCCESS': {
        return { ...state, list: action.data }
      }
      case 'TypeOfSubject_FAILED': {
        return { ...state, error: action.data }
      }
      default:
        return state;
    }
  }


export default goalReducer;